<template>
          <v-dialog v-model="showConfirm" persistent max-width="360">
          <v-card>
            <v-card-title class="headline primary--text">{{title}}</v-card-title>
            <v-card-text>
                <!--<span style="font-size: 1rem; color: #000000;">{{message}}</span>-->
                
                <v-row justify="space-around" style="align-items: baseline;">
                    <v-text-field
                      outlined
                      :label="$t('line.edit.container')"
                      v-model="containerNumber"
                      class="mt-5"
                      style="max-width: 80%"
                    ></v-text-field>
                    <v-btn
                      text
                      dark
                      small
                      color="primary"
                      @click="scanContainerNumber()"
                      style="min-width: 40px"
                    >
                      <v-icon dark>
                        mdi-barcode-scan
                      </v-icon>
                    </v-btn>
                </v-row>

                <v-row justify="space-around" style="align-items: baseline;">
                    <v-text-field
                      outlined
                      :label="$t('line.edit.flexi')"
                      v-model="flexiNumber"
                      style="max-width: 80%"
                    ></v-text-field>
                    <v-btn
                      text
                      dark
                      small
                      color="primary"
                      @click="scanFlexiNumber()"
                      style="min-width: 40px"
                    >
                      <v-icon dark>
                        mdi-barcode-scan
                      </v-icon>
                    </v-btn>
                </v-row>

                <v-row style="margin-top: -10px;">
                    <v-textarea
                      class="mx-2"
                      :label="$t('line.edit.comment')"
                      rows="1"
                      auto-grow
                      counter
                      clearable
                      clear-icon="mdi-close-circle"
                      v-model="depotComment"
                    ></v-textarea>
                </v-row>

                <!--<v-text-field
                    outlined
                    :label="$t('line.edit.container')"
                    v-model="containerNumber"
                    prepend-icon="mdi-barcode-scan"
                    class="mt-5"
                    @click="sendMessage()"
                    ></v-text-field>-->
                <!--<v-text-field
                    outlined
                    :label="$t('line.edit.flexi')"
                    v-model="flexiNumber"
                    prepend-icon="mdi-data-matrix-scan"
                    ></v-text-field>-->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="doConfirm" style="font-size: 1rem;">{{titleOk}}</v-btn>
              <v-btn v-if="!!titleCancel" text @click="doCancel" style="font-size: 1rem;">{{titleCancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
import cordova from "../../../api/cordova";

  export default {
    name: 'EditDialog', 
    props: ['message','titleOk','titleCancel','title'],
    data(){
        return { 
             flexiNumber:null,
             containerNumber:null,
             depotComment:null,
             showConfirm: false,
             reading:null,
        }

    },  
    methods: {
        confirm(flexiNumber,containerNumber, depotComment)
        { 
            window.$vue.$off('ne_backbutton');
            window.$vue.$on('ne_backbutton', this.processBackButton);
            window.$vue.$off('barcode:scan');
            window.$vue.$on('barcode:scan', this.processBarCodes);
            this.flexiNumber=flexiNumber;
            this.containerNumber=containerNumber;
            this.depotComment=depotComment;
            this.showConfirm=true;
        }
        ,
        doConfirm()
        {
            this.showConfirm = false;
            this.$emit('confirmed',{flexiNumber:this.flexiNumber, containerNumber:this.containerNumber, depotComment: this.depotComment});
        },
        doCancel()
        {
            this.showConfirm = false;
            this.$emit('canceled',{flexiNumber:this.flexiNumber, containerNumber:this.containerNumber, depotComment: this.depotComment});
        },
        scanContainerNumber(){
            //TODO: local variable or message it to cordova??
            this.reading=1;
            cordova.sendBarcodeScan();
        },
        scanFlexiNumber(){
            //TODO: local variable or message it to cordova??
            this.reading=2;
            cordova.sendBarcodeScan();
        },
        processBarCodes(data){
            var result = JSON.parse(data);
            var strResult = result.Result;
            if(this.reading==1){
                this.containerNumber = strResult;
            }else if(this.reading==2){
                this.flexiNumber = strResult;
            }
        },
        processBackButton: function() {
            window.$vue.$off('ne_backbutton');
            this.showConfirm = false;
        }
      },
    mounted() {
    }
  }
</script>